<script>
export default {
  props: {
    color: {
      default: () => {
        return 'white'
      },
      type: String,
    },
  },
}
</script>

<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20" cy="20" r="20" fill="#ACACAC" />
    <g clip-path="url(#clip0_209_795)">
      <path
        d="M22.81 19.9999L28.42 14.3899C29.19 13.6199 29.19 12.3599 28.42 11.5799C27.65 10.8099 26.39 10.8099 25.61 11.5799L20 17.1899L14.39 11.5799C13.61 10.8099 12.36 10.8099 11.58 11.5799C10.8 12.3499 10.81 13.6099 11.58 14.3899L17.19 19.9999L11.58 25.6099C10.81 26.3799 10.81 27.6399 11.58 28.4199C12.35 29.1899 13.61 29.1899 14.39 28.4199L20 22.8099L25.61 28.4199C26.38 29.1899 27.64 29.1899 28.42 28.4199C29.19 27.6499 29.19 26.3899 28.42 25.6099L22.81 19.9999Z"
        :fill="color"
        style="transform: scale(0.8) translate(5px, 6px)"
      />
    </g>
    <defs>
      <clipPath id="clip0_209_795">
        <rect
          width="18"
          height="18"
          :fill="color"
          transform="translate(11 11)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
